import api from "../index";

export const GetCreditInOutTransactionApi = (params) => api.get(`WalletMaster/Get-Credit-In-out-Transaction?${params}`);
export const GetUserNameByTerminalIdAdpi = (TerminalId) => api.get(`Admin/Get-UserName-By-TerminalId/${TerminalId}`);
export const AddCreditTransactionApi = (data) => api.post('WalletMaster/Add-Credit-Transaction', data);
export const AddAccountToAccountApi = (data) => api.post('WalletMaster/Admin/Transfer-Terminal-to-Terminal', data);

export const WithdrawScalpingApi = (data) => api.post('WalletMaster/Scalping-withdraw', data);